// import axios from "axios";
import * as d3 from "d3";
import {inrFormatterV2, multiColumnSort, resetFilterFlagTabalebarChart, wrapsword} from '../functions'
import {
    tableBarVisibleHeaderKeys,
    tableBarHeaderDisplayLabel,
} from '../columnMappingCore'

window.toggleJourneyInline = function (el) {
    const pre = el.parentElement.querySelector(".journey-json");

    if (pre.style.display === "none") {
        if (!pre.textContent) {
            let raw = pre.getAttribute("data-json");
            let parsed;

            try {
                // ✅ Handle both STRING JSON and OBJECT JSON
                parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
            } catch (e) {
                parsed = raw;
            }

            // ✅ Pretty print → each object on new lines
            pre.textContent = JSON.stringify(parsed, null, 2);
        }

        pre.style.display = "block";
        el.textContent = "📂 Hide";
    } else {
        pre.style.display = "none";
        el.textContent = "📄 View";
    }
};

export default function (chart, divId,vizName,resData,paramName,checkbox, gridflag,showValuesFlag,resetfilter) {
    /*Imp Note:
    1. Graph col must be end with '#' (like: DevLastWkRev%#).
    2. which metric will display the graph same number to be put the graph also.
    ie. if we want to print the graph metric3, so graph also be graph3.
*/
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName;
    // console.log("table bar", url)
    // axios.post(url, filterParam).then(res => {
        // Shallow copy rows and stamp original index so multi-column sort reset and tie-breaks work;
        // avoids mutating the caller's resData array.
        let data = (resData || []).map(function (row, i) {
            return Object.assign({}, row, { __originalIndex: i });
        });
        console.log("resetfilter",paramName,checkbox, gridflag,showValuesFlag,resetfilter)
        // Filter null and undefined values from the data
        //let filteredData = Object.entries(data[0]).reduce((a,[k,v]) => (v == null ? a: (a[k]=v, a) ), {})

        // Setup the scale for the values for display, use abs max as max value
        var titleMap = chart.reportHeaderColumnDp;
        console.log("titleMap:", titleMap)
        // get the keys from filtered data which filtered null, undefined columns

        /* Column order: use reportHeaderColumnDp keys only (titles) so headers and cells match */
        var titles = tableBarVisibleHeaderKeys(titleMap)

        var reportHeaderNewSet = (function () {
            var arr = chart.data && chart.data.reportHeaderNewColumnTitles;
            if (!arr || !arr.length) return {};
            var o = {};
            for (var ni = 0; ni < arr.length; ni++) o[arr[ni]] = true;
            return o;
        })();
        function tbcColHeadClass(titleKey) {
            return reportHeaderNewSet[titleKey] ? "tbc-col-head tbc-col-head--new" : "tbc-col-head";
        }
        var TBC_NEW_COL_TOOLTIP = "Added in your saved column layout (not in the screen default).";

    const uniqueValues = data.map(item => item.dim2_name);

    console.log("titles", titles, "uniqueValues", uniqueValues)
        /* to make soting fun work properly based on data dim names,
        create a title mapping between dp names and backend dim names */
       // var sortAscending = true;
        var view = chart.vizSpecific6

        // Colors: fall back to sensible defaults if not configured on chart
        const positiveColor = chart.vizSpecific4 || "#1f77b4";
        const negativeColor = chart.vizSpecific5 || "#ff7f0e";
        console.log("reportHeaderColumnDpWordwrap",chart.reportHeaderColumnDpWordwrap);
        const jsonData=chart.reportHeaderColumnDpWordwrap;
        const vebdorname=jsonData.wordwrap['table heading'];
        const vendoraddres=jsonData.wordwrap['table data'];
        console.log("vebdorname",vebdorname);
        console.log("vendoraddres",vendoraddres);
        //Table reports plotting two times need to revisit
        // Clear any previously rendered table header/body inside this container
        d3.select(divId).selectAll(".tbc-header-table, .tbc-body-table").remove();

    // Use the hosting container (e.g. .scrollmenu in menu-config or vizlet)
    // as the scroll area; let its CSS control max-height (300px, 75vh, etc.).
    // Here we only ensure it can scroll horizontally when content is wider.
    var scrollWrap = d3.select(divId)
        .classed("tbc-chart-scroll", true)
        .style("width", "100%")
        .style("overflow-x", "auto");

    var tableStyles = {
        "border-collapse": "collapse",
        "font-family": "'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif",
        "font-size": "16px",
        "background-color": "#ffffff"
    };

    // Sticky header: separate table so position:sticky works reliably in scroll container
    var headerTable = scrollWrap
        .append("table")
        .attr("class", "tbc-table tbc-header-table")
        .style("table-layout", "fixed")
        .style("position", "sticky")
        .style("top", "0")
        .style("z-index", "2")
        .style("margin-bottom", "0")
        .style("box-shadow", "0 2px 4px rgba(0,0,0,0.08)")
        .style("background-color", "#1f2937")
        .style("width", "100%");
    Object.keys(tableStyles).forEach(function (k) { headerTable.style(k, tableStyles[k]); });

    var table = scrollWrap
        .append("table")
        .attr("class", "tbc-table tbc-body-table")
        .style("border-radius", "6px")
        .style("box-shadow", "0 1px 3px rgba(15, 23, 42, 0.08)")
        .style("table-layout", "fixed")
        .style("width", "100%")

    Object.keys(tableStyles).forEach(function (k) { table.style(k, tableStyles[k]); });
    let sortState = []; // Array to track sort columns and directions
    var tbody = null; // assigned below; used by sort (closure) after rows exist

    var TBC_COL_MIN = 52;
    var TBC_COL_MAX = 640;
    var TBC_RESIZER_HIT = 12;
    /** Title key → px width; source of truth so drag + sync don't fight table-layout:auto remeasure */
    var columnPixelWidths = Object.create(null);

    function seedMissingColumnWidthsFromDom() {
        var thNodes = headerTable.selectAll("th").nodes();
        for (var si = 0; si < titles.length; si++) {
            var k = titles[si];
            if (columnPixelWidths[k] != null) continue;
            var th = thNodes[si];
            if (!th) continue;
            var w = Math.round(th.getBoundingClientRect().width);
            if (!Number.isFinite(w) || w < TBC_COL_MIN) w = TBC_COL_MIN;
            columnPixelWidths[k] = Math.min(TBC_COL_MAX, w);
        }
    }

    function applyStoredColumnWidths(opts) {
        opts = opts || {};
        seedMissingColumnWidthsFromDom();
        var thNodes = headerTable.selectAll("th").nodes();
        var sum = 0;
        for (var ai = 0; ai < titles.length; ai++) {
            var colKey = titles[ai];
            var w = columnPixelWidths[colKey];
            if (w == null) {
                var th0 = thNodes[ai];
                w = th0 ? Math.round(th0.getBoundingClientRect().width) : TBC_COL_MIN;
            }
            w = Math.round(Math.min(TBC_COL_MAX, Math.max(TBC_COL_MIN, w)));
            columnPixelWidths[colKey] = w;
            sum += w;
            var thN = thNodes[ai];
            if (thN) {
                d3.select(thN)
                    .style("width", w + "px")
                    .style("min-width", w + "px")
                    .style("max-width", w + "px");
            }
            var cells = table.selectAll("td").filter(function (td) {
                return td && td.key === colKey;
            });
            cells
                .style("width", w + "px")
                .style("min-width", w + "px")
                .style("max-width", w + "px");
            if (!opts.skipBarContainers) {
                cells.select(".tbc-bar-container")
                    .style("width", "100%")
                    .style("max-width", "100%")
                    .style("box-sizing", "border-box")
                    .style("min-width", "0");
            }
        }
        var wrapEl = scrollWrap.node();
        var wrapWidth = wrapEl ? wrapEl.clientWidth : 0;
        var tableWidth = Math.max(wrapWidth, sum + 4);
        table.style("width", tableWidth + "px").style("min-width", tableWidth + "px");
        headerTable.style("width", tableWidth + "px").style("min-width", tableWidth + "px");
    }

    function syncColumnWidths(opts) {
        opts = opts || {};
        if (opts.remeasureAll) {
            for (var ri = 0; ri < titles.length; ri++) {
                delete columnPixelWidths[titles[ri]];
            }
        }
        applyStoredColumnWidths({});
    }

        /** Column resize: rAF-smoothed; updates columnPixelWidths so post-drag sync does not revert width */
        function attachColumnResizer(thSel, key) {
            thSel
                .style("position", "relative")
                .style("min-width", TBC_COL_MIN + "px");

            var resizer = thSel.append("div")
                .attr("class", "tbc-resizer")
                .style("position", "absolute")
                .style("right", -(TBC_RESIZER_HIT / 2) + "px")
                .style("top", "0")
                .style("width", TBC_RESIZER_HIT + "px")
                .style("height", "100%")
                .style("cursor", "col-resize")
                .style("user-select", "none")
                .style("-webkit-user-select", "none")
                .style("z-index", "4")
                .style("background-color", "transparent")
                .style("touch-action", "none");

            resizer.append("div")
                .attr("class", "tbc-resizer-grip")
                .style("position", "absolute")
                .style("right", (TBC_RESIZER_HIT / 2 - 1) + "px")
                .style("top", "18%")
                .style("width", "2px")
                .style("height", "64%")
                .style("border-radius", "1px")
                .style("background", "rgba(255,255,255,0.22)")
                .style("box-shadow", "0 0 0 1px rgba(0,0,0,0.12)")
                .style("pointer-events", "none")
                .style("opacity", "0.85");

            var gripHover = "rgba(255,255,255,0.45)";
            var gripRest = "rgba(255,255,255,0.22)";

            resizer
                .on("mouseenter", function () {
                    if (d3.select(this).classed("tbc-resizer--dragging")) return;
                    d3.select(this).select(".tbc-resizer-grip").style("background", gripHover);
                })
                .on("mouseleave", function () {
                    if (d3.select(this).classed("tbc-resizer--dragging")) return;
                    d3.select(this).select(".tbc-resizer-grip").style("background", gripRest);
                });

            resizer.on("mousedown", function () {
                d3.event.preventDefault();
                d3.event.stopPropagation();

                var rafId = null;
                var pendingW = null;
                var lastApplied = -1;

                function applyColumnPixelWidth(wPx) {
                    var w = Math.round(Math.min(TBC_COL_MAX, Math.max(TBC_COL_MIN, wPx)));
                    if (w === lastApplied) return;
                    lastApplied = w;
                    columnPixelWidths[key] = w;
                    thSel
                        .style("width", w + "px")
                        .style("min-width", w + "px")
                        .style("max-width", w + "px");

                    var cells = table.selectAll("td").filter(function (td) {
                        return td && td.key === key;
                    });
                    cells
                        .style("width", w + "px")
                        .style("min-width", w + "px")
                        .style("max-width", w + "px");
                    cells.select(".tbc-bar-container")
                        .style("width", "100%")
                        .style("max-width", "100%")
                        .style("box-sizing", "border-box")
                        .style("min-width", "0");

                    seedMissingColumnWidthsFromDom();
                    var sum = 0;
                    var thNodes = headerTable.selectAll("th").nodes();
                    for (var ci = 0; ci < titles.length; ci++) {
                        var tk = titles[ci];
                        var cw = columnPixelWidths[tk];
                        if (cw == null) {
                            var th = thNodes[ci];
                            cw = th ? Math.round(th.getBoundingClientRect().width) : TBC_COL_MIN;
                            columnPixelWidths[tk] = cw;
                        }
                        sum += cw;
                    }
                    var wrapEl = scrollWrap.node();
                    var tw = Math.max(wrapEl ? wrapEl.clientWidth : 0, sum + 4);
                    table.style("width", tw + "px").style("min-width", tw + "px");
                    headerTable.style("width", tw + "px").style("min-width", tw + "px");
                }

                function flushFrame() {
                    rafId = null;
                    if (pendingW != null) {
                        applyColumnPixelWidth(pendingW);
                    }
                }

                function scheduleWidth(wPx) {
                    pendingW = wPx;
                    if (rafId == null) {
                        rafId = requestAnimationFrame(flushFrame);
                    }
                }

                var startX = d3.event.clientX;
                var node = thSel.node();
                var computed = window.getComputedStyle(node);
                var startWidth = parseFloat(computed.width) || node.getBoundingClientRect().width;

                var prevUserSelect = document.body.style.userSelect;
                var prevCursor = document.body.style.cursor;
                document.body.style.userSelect = "none";
                document.body.style.cursor = "col-resize";
                scrollWrap.classed("tbc-scroll-wrap--resizing", true);
                thSel.classed("tbc-th-resizing", true);
                resizer.classed("tbc-resizer--dragging", true);
                resizer.select(".tbc-resizer-grip").style("background", "rgba(96,165,250,0.95)");

                var resizeEnded = false;
                function endDrag() {
                    if (resizeEnded) return;
                    resizeEnded = true;
                    if (rafId != null) {
                        cancelAnimationFrame(rafId);
                        rafId = null;
                    }
                    if (pendingW != null) {
                        applyColumnPixelWidth(pendingW);
                        pendingW = null;
                    }
                    d3.select(window)
                        .on("mousemove.tbc-resize", null)
                        .on("mouseup.tbc-resize", null);
                    window.removeEventListener("blur", onBlurResize);
                    document.body.style.userSelect = prevUserSelect;
                    document.body.style.cursor = prevCursor;
                    scrollWrap.classed("tbc-scroll-wrap--resizing", false);
                    thSel.classed("tbc-th-resizing", false);
                    resizer.classed("tbc-resizer--dragging", false);
                    resizer.select(".tbc-resizer-grip").style("background", gripRest);

                    requestAnimationFrame(function () {
                        requestAnimationFrame(function () {
                            applyStoredColumnWidths({});
                        });
                    });
                }

                function onBlurResize() {
                    endDrag();
                }

                window.addEventListener("blur", onBlurResize);

                d3.select(window)
                    .on("mousemove.tbc-resize", function () {
                        var dx = d3.event.clientX - startX;
                        scheduleWidth(startWidth + dx);
                    })
                    .on("mouseup.tbc-resize", function () {
                        endDrag();
                    });
            });
        }

        // Font Awesome 5 Free (same code points as custom.css for tbc-header / tbc-aes / tbc-des :after).
        // glyphs live on .tbc-sort-glyph inside the header so <th> does not need .tbc-header (no custom.css).
        var TBC_SORT_GLYPH_NEUTRAL = String.fromCharCode(0xf0dc);
        var TBC_SORT_GLYPH_ASC = String.fromCharCode(0xf884);
        var TBC_SORT_GLYPH_DESC = String.fromCharCode(0xf885);

        // Create table header (in sticky header table)
        var headers = headerTable.append('thead')
            .append('tr')
            .selectAll('th')
            .data(titles)
            .enter()
            .append('th')
            .attr("class", tbcColHeadClass)
            .style("background", "linear-gradient(90deg, #1f2937, #111827)")
            // Compact header height
            .style("padding", "4px 8px")
            .style("text-align", "center")
            .style("font-size", "16px")
            .style("color", "#fff")
            // Match resizer's base min-width so columns can shrink sensibly
            .style("min-width", "72px")
            .style("max-width", "none")
            .style("overflow", "visible")
            // .style("width", '0px')
            .style("border-bottom", "1px solid #374151")
            .style("position", "sticky")
            .style("top", "0")
            .style("z-index", "1")
            .each(function (d) {
                // Build header content: label + sort icon (only these two trigger sort, not the whole th)
                var th = d3.select(this);
                th.html("");

                var content = th.append("div")
                    .attr("class", "tbc-header-content")
                    .style("display", "inline-flex")
                    .style("align-items", "center")
                    .style("justify-content", "center")

                function resolveSortDataColumn(headerKey) {
                    var mapped = titleMap[headerKey];
                    if (mapped == null) return mapped;
                    if (typeof mapped === 'string' && /^graph/i.test(mapped)) {
                        return mapped.replace(/^graph/i, 'metric');
                    }
                    if (typeof headerKey === 'string' && headerKey.endsWith('#') && typeof mapped === 'string') {
                        return mapped.replace(/^graph/i, 'metric');
                    }
                    return mapped;
                }

                function applyZebraStripes() {
                    if (!tbody) return;
                    tbody.selectAll('tr').each(function (rowD, i) {
                        var bg = i % 2 === 0 ? '#ffffff' : '#f9fafb';
                        var row = d3.select(this);
                        row.attr('data-bg', bg);
                        row.style('background-color', bg);
                    });
                }

                function doSort(key) {
                    let dataColumn = resolveSortDataColumn(key);
                    const existingIndex = sortState.findIndex(item => item.column === dataColumn);
                    if (existingIndex >= 0) {
                        if (sortState[existingIndex].direction === 'asc') {
                            sortState[existingIndex].direction = 'desc';
                        } else {
                            sortState.splice(existingIndex, 1);
                        }
                    } else {
                        sortState.push({ column: dataColumn, direction: 'asc' });
                    }
                    var rowSelection = tbody ? tbody.selectAll('tr') : tr;
                    if (sortState.length > 0) {
                        const sortColumns = sortState.map(item => item.column);
                        const sortDirections = sortState.map(item => item.direction);
                        rowSelection.sort(multiColumnSort(sortColumns, sortDirections));
                    } else {
                        rowSelection.sort(function (a, b) {
                            return (a.__originalIndex | 0) - (b.__originalIndex | 0);
                        });
                    }
                    applyZebraStripes();
                    headers.attr("class", tbcColHeadClass);
                    headers
                        .select(".tbc-sort-glyph")
                        .style("color", "#ffffff")
                        .text(TBC_SORT_GLYPH_NEUTRAL);
                    headers.select('.sort-order').remove();
                    if (sortState.length > 0) {
                        sortState.forEach((sortItem, index) => {
                            const header = headers.filter(function (h) {
                                const col = titleMap[h];
                                if (col == null || sortItem.column == null) return false;
                                if (col === sortItem.column) return true;
                                if (typeof col === 'string' && /^graph/i.test(col)) {
                                    return col.replace(/^graph/i, 'metric') === sortItem.column;
                                }
                                return false;
                            });
                            header.attr("class", tbcColHeadClass);
                            header
                                .select(".tbc-sort-glyph")
                                .style("color", "#ffd700")
                                .text(
                                    sortItem.direction === "asc"
                                        ? TBC_SORT_GLYPH_ASC
                                        : TBC_SORT_GLYPH_DESC
                                );
                            header.select('.tbc-header-content')
                                .append('span')
                                .attr('class', 'sort-order')
                                .style('font-size', '0.7em')
                                .style('margin-left', '2px')
                                .style('opacity', '0.9')
                                .text(index + 1);
                        });
                    }
                }

                function onSortClick() {
                    d3.event.preventDefault();
                    d3.event.stopPropagation();
                    doSort(d);
                }

                var labelSpan = content.append("span")
                    .attr("class", "tbc-header-label")
                    .style("overflow", "hidden")
                    .style("text-overflow", "ellipsis")
                    .style("white-space", "nowrap")
                    .style("line-height", "1.4")
                    .style("cursor", "pointer")
                    .text(wrapsword(tableBarHeaderDisplayLabel(d), vebdorname));
                labelSpan.on("click", onSortClick);

                if (reportHeaderNewSet[d]) {
                    th.attr("title", TBC_NEW_COL_TOOLTIP);
                    content.append("i")
                        .attr("class", "tbc-header-new-icon fas fa-certificate")
                        .attr("aria-hidden", "true");
                }

                var sortGlyph = content.append("span")
                    .attr("class", "tbc-sort-glyph")
                    .style("font-family", "'Font Awesome 5 Free'")
                    .style("font-weight", "900")
                    .style("color", "#ffffff")
                    .style("margin-left", "4px")
                    .style("flex-shrink", "0")
                    .style("cursor", "pointer")
                    .style("font-size", "0.9em")
                    .style("line-height", "1")
                    .text(TBC_SORT_GLYPH_NEUTRAL);
                sortGlyph.on("click", onSortClick);

                attachColumnResizer(th, d);
            })

    // Create body table rows (append to tbody so we have thead only in header table)
        tbody = table.append('tbody');
        var tr = tbody.selectAll('tr.g').data(data).enter().append('tr');
        //selectAll selects the already available tr element so it skips the data first row
        //https://stackoverflow.com/questions/19182775/d3-data-skipping-the-first-row-of-data

        // Zebra striping + hover highlight for richer UX
        tr.attr("class", "tbc-row")
            .attr("data-bg", function (d, i) {
                return i % 2 === 0 ? "#ffffff" : "#f9fafb";
            })
            .style("background-color", function () {
                return d3.select(this).attr("data-bg");
            })
            .on("mouseenter", function () {
                d3.select(this).style("background-color", "#eef2ff");
            })
            .on("mouseleave", function () {
                d3.select(this).style("background-color", d3.select(this).attr("data-bg"));
            });

        // One td per reportHeaderColumnDp column, in same order as headers
        tr.selectAll('td')
            .data(function (d, i) {
                return titles.map(function (key) {
                    var dataKey = titleMap[key];
                    return {
                        value: d[dataKey],
                        name: dataKey,
                        key: key,
                        rowIndex: i,
                        isGraph: dataKey.startsWith('graph'),
                        rowData: d
                    };
                });
            })
            .enter()
            .append('td')
            .attr("class", (d) => {
                var base = d.isGraph ? "tbc-" + d.name : "reptd";
                return reportHeaderNewSet[d.key] ? base + " tbc-td--new" : base;
            })
            .attr('data-th', (d) => d.key)
            .attr("width", (d) => d.isGraph ? 2 * chart.width : null)
            .each(function (cellD) {
                var el = d3.select(this);
                if (cellD.isGraph) {
                    var val = cellD.name;
                    var valMetric = val.replace('graph', 'metric');
                    var rawValue = cellD.rowData ? cellD.rowData[valMetric] : undefined;
                    var formattedValue =
                        rawValue != null
                            ? inrFormatterV2(rawValue, chart.data?.menuId)
                            : "";
                    var tooltipValue = formattedValue;
                    var suffix = val.replace('graph', '');

                    var container = el.append("div")
                        .attr("class", "tbc-bar-container")
                        .style("width", "100%")
                        .style("max-width", "100%")
                        .style("box-sizing", "border-box")
                        .style("min-width", "0")
                        .style("display", "flex")
                        .style("align-items", "center")
                        .style("height", "18px");

                    // Background track
                    var barWrapper = container.append("div")
                        .attr("class", "tbc-bar-wrapper" + suffix)
                        .style("position", "relative")
                        .style("flex", "1")
                        .style("min-width", "0")
                        .style("height", "100%")
                        .style("background-color", "#e5e7eb")
                        .style("border-radius", "4px")
                        .style("overflow", "hidden");

                    // Filled portion of the bar
                    barWrapper.append("div")
                        .attr("class", "tbc-bar-fill" + suffix)
                        .attr("title", tooltipValue)
                        .style("position", "absolute")
                        .style("left", "0")
                        .style("top", "0")
                        .style("height", "100%")
                        .style("width", "0%")
                        .style("background-color", positiveColor);

                    // Centered value label (no % symbol, just the value)
                    barWrapper.append("div")
                        .attr("class", "tbc-bar-label" + suffix)
                        .style("position", "absolute")
                        .style("left", "0")
                        .style("top", "0")
                        .style("width", "100%")
                        .style("height", "100%")
                        .style("display", "flex")
                        .style("align-items", "center")
                        .style("justify-content", "center")
                        .style("font-size", "11px")
                        .style("color", "#111827")
                        .style("pointer-events", "none")
                        .text(formattedValue);
                } else {
                    var html = '';
                    var isMobile = window.innerWidth <= 767;
                    if (cellD.name.startsWith('metric')) {
                        html = inrFormatterV2(cellD.value, chart.data?.menuId);
                    } else if (cellD.name === 'hyperlink') {
                        html = '<a ' + (isMobile ? '' : 'target="_blank"') + ' href="' + cellD.value + '">' + view + '</a>';
                    } else if (cellD.name === 'menulink') {
                        html = '<a ' + (isMobile ? '' : 'target="_blank"') + ' href="' + cellD.value + '">' + uniqueValues[cellD.rowIndex] + '</a>';
                    } else if (cellD.name === 'jsonView') {
                        if (cellD.value) {
                            html = '<div class="journey-wrapper" style="padding:0;margin:0">' +
                                '<span style="cursor:pointer;color:#4da3ff;font-weight:600;display:inline-block;margin-bottom:4px" onclick="toggleJourneyInline(this)">📄 View</span>' +
                                '<pre class="journey-json" style="display:none;margin:0;padding:6px;background:#ede9e9;color:#000000;max-height:280px;overflow:auto;font-size:12px;border-radius:4px;line-height:1.3" data-json=\'' + cellD.value + '\'></pre></div>';
                        }
                    } else {
                        html = cellD.value != null ? cellD.value : '';
                    }
                    el.html(html);
                }
            })
            .style("text-align", (d) => {
                const isMetric = d.name.startsWith('metric');
                const isSrcStart = d.name.startsWith('src');
                const isIdEnd = d.name.endsWith('id');
                return (isMetric || isSrcStart || isIdEnd) ? 'right' : 'left'
            })
            .style("color", (d) => {
                const isMetric = d.name.startsWith('metric');
                const isSrcStart = d.name.startsWith('src');
                const isIdEnd = d.name.endsWith('id');
                if (isMetric || isSrcStart || isIdEnd) {
                    return d.value >= 0 ? positiveColor : negativeColor;
                }
            })
            .style("white-space", (d) => {
                return d.isGraph ? null : (d.name === 'jsonView' ? 'normal' : 'pre');
            })
            .style("line-height", "1.2")
            .style("padding", "6px 8px")
            .style("border-bottom", "1px solid #e5e7eb")
            // For data cells, keep constrained width/ellipsis; graph cells clip so bars cannot overflow into the next column
            .style("width", (d) => (d.isGraph ? null : "0px"))
            .style("overflow", "hidden")
            .style("text-overflow", (d) => (d.isGraph ? "clip" : "ellipsis"));

        // Apply graph bar scales and widths (one scale per graph column)
        titles.forEach(function (key) {
            var dataKey = titleMap[key];
            if (dataKey.startsWith('graph')) {
                var val = dataKey;
                var valMetric = val.replace('graph', 'metric');
                var suffix = val.replace('graph', '');
                var maxAbs = d3.max(data, function (d) {
                    var v = d[valMetric];
                    return v != null ? Math.abs(v) : 0;
                }) || 0;
                var x1Scale = d3.scaleLinear()
                    .domain([0, maxAbs === 0 ? 1 : maxAbs])
                    .range([0, 100]);

                tr.select("div.tbc-bar-fill" + suffix)
                    .style("width", "0%")
                    .transition()
                    .duration(500)
                    .style("width", function () {
                        var rowD = d3.select(this.closest('tr')).datum();
                        var v = rowD[valMetric];
                        if (v == null) return "0%";
                        return x1Scale(Math.abs(v)) + "%";
                    })
                    .style("background-color", function () {
                        var rowD = d3.select(this.closest('tr')).datum();
                        var v = rowD[valMetric];
                        // Positive: keep configured positiveColor
                        // Negative: force a clear red so it stands out
                        return v >= 0 ? positiveColor : "#ef4444";
                    });
            }
        });

        function runSyncAfterLayout() {
            requestAnimationFrame(function () {
                syncColumnWidths({});
            });
        }
        runSyncAfterLayout();

        var resizeHandler = function () {
            if (!scrollWrap.node() || !document.contains(scrollWrap.node())) {
                window.removeEventListener("resize", resizeHandler);
                return;
            }
            syncColumnWidths({ remeasureAll: true });
        };
        window.addEventListener("resize", resizeHandler);

    resetFilterFlagTabalebarChart(false)
}
